import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "success",
  "use": "success-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"success\">\n    <path fill=\"#36B37E\" fill-rule=\"evenodd\" d=\"M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0zm9.616 15.146l-13.82 13.303-6.444-6.372-3.164 3.2 9.568 9.46 16.98-16.35-3.12-3.241z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol